<div class="logo">
  <i class="fa fa-wrench"></i> Administración
</div>
<button mat-button [routerLink]="'database'" routerLinkActive="active"><i class="fa fa-database"></i><span class="label">Bases de datos</span></button>
<div class="expander"></div>
